export default {
      id: "oc-ksyun-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "sprite.svg#oc-ksyun",
      toString: function () {
        return this.url;
      }
    }